/*
API requests to the dd backend
*/
import { apiRequest } from '../../plugins/core/dd.data.connect.js'

export const saveGeoZone = (data, params) => {
  var p = new Promise((resolve, reject) => {

    let method = 'POST'
    let url    = '/geo-zones'

    if(data.id){
      method = 'PUT'
      url   += `/${data.id}`
    }
    
    apiRequest(method, url, data, params).then((res) => {
      resolve(res.data)
    }).catch((e) => {      
      reject(e)
    })
  })
  return p
}

export const deleteGeoZone = (data, params) => {

    var p = new Promise((resolve, reject) => {
      apiRequest('DELETE',`/geo-zones/${data.id}`,null, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }

export const allGeoZones = (data, params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET','/geo-zones', data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
}

export const searchGeoZones = (data, params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET',`/geo-zones/search/${data.value}`, {}, params).then((res) => {
        resolve(res)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
}  

  export const unitTypeGeoZoneEvents = (data, params) => {
    var p = new Promise((resolve, reject) => {
      if(!data.unitTypeId){
        throw Error("unitTypeId is mandatory")        
      }
      apiRequest('GET',`/unit-types/${data.unitTypeId}/geo-zone-events`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }

  export const geoZoneEventsOnUnitTypeAndGeoZone = (data, params) => {
    var p = new Promise((resolve, reject) => {

      if(!data.unitTypeId){
          throw reject("unitTypeId is mandatory")        
      }
      if(!data.geoZoneId){
          throw reject("GeoZoneId is mandatory")        
      }                  

      apiRequest('GET',`/geo-zone-events/unit-types/${data.unitTypeId}/geo-zones/${data.geoZoneId}`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject([])
      })
    })    

    return p
  }

  export const unitTypeGeoZoneEventsSearch = (data, params) => {
    var p = new Promise((resolve, reject) => {
      if(!data.unitTypeId){
        throw Error("unitTypeId is mandatory")        
      }
      apiRequest('GET',`/unit-types/${data.unitTypeId}/geo-zone-events/search/${data.value}`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }  

  export const getGeoZone = (data, params) => {
    var p = new Promise((resolve, reject) => {
      if(!data.id)
        reject("id is mandatory")
      apiRequest('GET',`/geo-zones/${data.id}`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }

  export const getAssetsWithinGeoZone = (data, params) => {
    var p = new Promise((resolve, reject) => {

      if(!data.id)
        throw("id is mandatory")      
      
      apiRequest('GET',`/geo-zones/${data.id}/assets-within-geo-zone`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }  

  export const getEventsWithinGeoZone = (data, params) => {
    var p = new Promise((resolve, reject) => {

      if(!data.id)
        throw("id is mandatory")      
      
      apiRequest('GET',`/geo-zones/${data.id}/events-within-geo-zone`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }  

  export const getGeoZoneProcessedEvents = (data, params) => {
    var p = new Promise((resolve, reject) => {

      if(!data.id)
        throw("id is mandatory")      
      
      apiRequest('GET',`/geo-zones/${data.id}/processed-geo-zone-events`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }  

  export const saveCustomFieldsOnGeoZone = (data, params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('POST',`/geo-zone-custom-fields/mass-assign`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }

  export const saveGeoZoneCustomFieldValues = (data, params) => {
      var p = new Promise((resolve, reject) => {

        if(!data.geoZoneId)
          reject("geo_zone_id is mandatory")

        apiRequest('PUT',`/geo-zones/${data.geoZoneId}/custom-fields`, data.fields, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {      
          reject(e)
        })
      })
      return p    
  }

  export const allGeoZoneCustomFields = (data, params) => {
    var p = new Promise((resolve, reject) => {

      apiRequest('GET',`/geo-zone-custom-fields`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }
  export const getAssetGroupGeoZoneEventsOnGeoZone  = (data,params) => {
    var p = new Promise((resolve, reject) => {
      if(!data.id){
        reject('id is mandatory')
      }
      apiRequest('GET',`/geo-zones/${data.id}/asset-group-geo-zone-events`, data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p    
  }

  export const allGeoZoneTypes = (data, params) => {
    var p = new Promise((resolve, reject) => {
      apiRequest('GET','/geo-zone-types', data, params).then((res) => {
        resolve(res.data)
      }).catch((e) => {      
        reject(e)
      })
    })
    return p
  }

  export const saveGeoZoneType = (data, params) => {
    
    let method = "POST"
    let url    = "/geo-zone-types"

    // GeoZoneTypes is known change call to PUT
    if(data.id) {
        url += '/'+data.id      
        method = "PUT"
    }
  
    var p = new Promise((resolve, reject) => {
        apiRequest(method, url, data, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {      
          reject(e)
        })      
    })  
    return p  
  }  

  export const saveGeoZoneEvent = (data, params) => {

    if(!data.onEnterUnitTypeEventId && !data.onExitUnitTypeEventId)
      throw Error("Minimal enter or exit event id must be given")
    
    let method = "POST"
    let url    = "/geo-zone-events"

    // geozoneEvent is known change call to PUT
    if(data.geoZoneEventId) {
        url += '/'+data.geoZoneEventId      
        method = "PUT"
    }
    else if(!data.geoZoneId){
      throw Error("geoZoneId is mandatory of geoZoneEventId is not given")
    }

  
    var p = new Promise((resolve, reject) => {
        apiRequest(method, url, data, params).then((res) => {
          resolve(res.data)
        }).catch((e) => {      
          reject(e)
        })      
    })  
    return p  
  }

  export const assetsInGeoZoneSince = (data, params) => {
    
    if(!data.geoZoneId){
        throw Error("datafield geoZoneId is mandatory")      
    }

    let method = "GET"
    let url    = "/geo-zones/"+data.geoZoneId+"/assets-since"      

    var p = new Promise((resolve, reject) => {
        apiRequest(method, url, {}, {}).then((res) => {
          resolve(res)
        }).catch((e) => {      
          reject(e)
        })      
    })  
    return p  
  }  

  export const geoCodeAddress = (data, params) => {
    
    if(!data.city){
      throw Error("datafield city is mandatory")      
    }    

    var p = new Promise((resolve, reject) => {
        apiRequest("GET", `/addresses/geocode?city=${data.city}&street=${data.street}&houseNumber=${data.houseNumber}`, {}, {}).then((res) => {          
          resolve(res.data)
        }).catch((e) => {      
          reject(e)
        })      
    })  
    return p      
  }

